export default __webpack_public_path__ + "206eddd.png";